import { render, staticRenderFns } from "./chooseBox.vue?vue&type=template&id=3ee34fcf&scoped=true&"
import script from "./chooseBox.vue?vue&type=script&lang=js&"
export * from "./chooseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee34fcf",
  null
  
)

export default component.exports